// const CryptoJS = require("crypto-js");
import SHA512 from "crypto-js/sha512";
import Hex from "crypto-js/enc-hex";

const updateArrayByKey = ({ array, obj, key, val, defaultVal }) => {
  return array.map((el) => {
    const returnValue = { ...el };
    if (el === obj) {
      returnValue[key] = val;
    } else if (defaultVal !== undefined) {
      returnValue[key] = defaultVal;
    }
    return returnValue;
  });
};

const timestampToDate = (ts) => {
  const date = new Date(ts * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const formattedTime = `${year}-${month}-${day}`;
  return formattedTime;
};

const validateEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
const sha512 = (raw) => SHA512(raw).toString(Hex);
const clearAccessToken = () => localStorage.setItem("jwt", "");
const getAccessToken = () => localStorage.getItem("jwt");
const updateJwt = (accessToken) => {
  clearAccessToken();
  localStorage.setItem("jwt", accessToken);
};

const hkoCodeToImageName = (code) => {
  return {
    WFIREY: "firey",
    WFIRER: "firer",
    WFROST: "frost",
    WHOT: "vhot",
    WCOLD: "cold",
    WMSGNL: "sms",
    WRAINA: "raina",
    WRAINR: "rainr",
    WRAINB: "wrainb",
    WFNTSA: "ntfl",
    WL: "landslip",
    TC1: "tc1",
    TC3: "tc3",
    TC8NE: "tc8ne",
    TC8SE: "tc8b",
    TC8NW: "tc8d",
    TC8SW: "tc8c",
    TC9: "tc9",
    TC10: "tc10",
    WTMW: "tsunami-warn",
    WTS: "ts",
  }[code];
};

const serializedChatSonic = (input) => {
  var serialized = [];
  input.split("event:").forEach((e) => {
    const eventAndData = e.split("data:");
    var event = "",
      data = "";
    eventAndData.forEach((el, i) => {
      console.log(el);
      if (i === 0) {
        event += el.replaceAll("\r", "");
      } else {
        // data += el.replaceAll("\n", "");
        data += el.replaceAll("\r\n\r\n", "").replace(" ", "");
      }
    });
    var d = {
      event: event,
      data: data,
    };
    serialized.push(d);
  });
  return serialized;
};

export {
  clearAccessToken,
  getAccessToken,
  hkoCodeToImageName,
  updateArrayByKey,
  timestampToDate,
  serializedChatSonic,
  sha512,
  updateJwt,
  validateEmail,
};
